import React from "react"
import Nav from "../components/Nav"
import About from "../components/About"

export default function AboutPage() {
  return (
    <>
      <Nav />
      <About />
    </>
  )
}
